import { fork, put, all, call, takeLatest } from "redux-saga/effects";

import {
  getOrgBillingSuccessful,
  getOrgBillingFailure,
  updateOrgBillingSuccessful,
  updateOrgBillingFailure,
  createOrgBillingSuccessful,
  createOrgBillingFailure,
  deleteOrgBillingSuccessful,
  deleteOrgBillingFailure,
  clearAllOrgBillingMessagesSuccessful,
} from "./organizationBillingSlice";

import {
  getOrgBilling as getOrgBillingApi,
  updateOrgBilling as updateOrgBillingApi,
  createOrgBilling as createOrgBillingApi,
  deleteOrgBilling as deleteOrgBillingApi,
} from "../../helpers/auth_helper";

function* getOrgBilling({ payload: orgCode }) {
  try {
    const response = yield call(getOrgBillingApi, orgCode);
    console.log("getOrgBilling Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(getOrgBillingSuccessful(Object.values(response)));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getOrgBillingFailure({ message: message }));
    }
  } catch (error) {
    console.log("getOrgBilling Error: ", error);
    if(error.response){
      yield put(getOrgBillingFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getOrgBillingFailure({message: "No response is received"}))
    } else{
      yield put(getOrgBillingFailure({message: error?.message}));
    }
  }
}

function* updateOrgBilling({ payload: updateOrgBillingPayload }) {
  try {
    const response = yield call(updateOrgBillingApi, updateOrgBillingPayload);
    console.log("updateOrgBilling Response: ", response);
    if( response && response.status === 200 ){
      // delete response.status;
      yield put(updateOrgBillingSuccessful(response.data));
    }
    else {
      let message;
      if(response.data) {
        message = response.data;
      } else {
        message = response;
      }
      yield put(updateOrgBillingFailure({ message: message }));
    }
  } catch (error) {
    console.log("updateOrgBilling Error: ", error);
    if(error.response){
      yield put(updateOrgBillingFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(updateOrgBillingFailure({message: "No response is received"}))
    } else{
      yield put(updateOrgBillingFailure({message: error?.message}));
    }
  }
}

function* createOrgBilling({ payload: createOrgBillingPayload }) {
  try {
    const response = yield call(createOrgBillingApi, createOrgBillingPayload);
    console.log("createOrgBilling Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(createOrgBillingSuccessful(response?.data));
    }
    else {
      let message;
      console.log("IN else:: ", response.data)
      if(response.data) {
        message = response.data;
      } else {
        message = response;
      }
      yield put(createOrgBillingFailure({ message: message }));
    }
  } catch (error) {
    console.log("createOrgBilling Error: ", error);
    if(error.response){
      yield put(createOrgBillingFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(createOrgBillingFailure({message: "No response is received"}))
    } else{
      yield put(createOrgBillingFailure({message: error?.message}));
    }
  }
}

function* deleteOrgBilling({ payload: deleteOrgBillingPayload }) {
  try {
    const response = yield call(deleteOrgBillingApi, deleteOrgBillingPayload);
    console.log("deleteOrgBilling Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(deleteOrgBillingSuccessful(Object.values(response).join("")));
    }
    else {
      let message;
      if(response.data) {
        message = response.data;
      } else {
        message = response;
      }
      yield put(deleteOrgBillingFailure({ message: message }));
    }
  } catch (error) {
    console.log("deleteOrgBilling Error: ", error);
    if(error.response){
      yield put(deleteOrgBillingFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(deleteOrgBillingFailure({message: "No response is received"}))
    } else{
      yield put(deleteOrgBillingFailure({message: error?.message}));
    }
  }
}

export function* clearAllOrgBillingMessages() {
  console.log("clearAllOrgBillingMessages Saga: clear all messages");
  yield put((clearAllOrgBillingMessagesSuccessful()));
}

function* watchOrganizationBillingSaga() {
  yield takeLatest("organizationBillingSlice/getOrgBilling", getOrgBilling);
  yield takeLatest("organizationBillingSlice/updateOrgBilling", updateOrgBilling);
  yield takeLatest("organizationBillingSlice/createOrgBilling", createOrgBilling);
  yield takeLatest("organizationBillingSlice/deleteOrgBilling", deleteOrgBilling);
  yield takeLatest("organizationBillingSlice/clearAllOrgBillingMessages", clearAllOrgBillingMessages);
}

function* organizationBillingSaga() {
  yield all([fork(watchOrganizationBillingSaga)]);
}

export default organizationBillingSaga;